import React from "react";
import { View, Modal, SafeAreaView, ActivityIndicator } from "react-native";

import ImgIcon from "components/imgIcon";

import { colors, sizes } from "assets/constants";
import css from "styles";
import { logo } from "assets/images";

export default function LoadingBox() {
  return (
    <Modal transparent animationType="fade">
      <SafeAreaView
        style={{
          ...css.centralElContainer,
          backgroundColor: colors.black + "99",
        }}
      >
        <View
          style={{
            width: 150,
            height: 150,
            ...css.centralElements,
            backgroundColor: colors.white,
            borderRadius: sizes.radius.lg,
          }}
        >
          <ImgIcon
            icon={logo.drawerLogo}
            style={{ width: 120, height: 100, top: -5 }}
          />

          <ActivityIndicator
            size={30}
            color={colors.theme}
            style={{ top: -15 }}
          />
        </View>
      </SafeAreaView>
    </Modal>
  );
}
